export const formatDateTime = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
  
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
  
    return [year, month, day].join("-");
  };
  
  export const formatDate = (date) => {
    return new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      day: "2-digit",
      month: "short",
    }).format(date);
  };
  
  export const formatTime = (date) => {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  
  export const formatText = (text) => {
    // Replace **bold text** with <b>bold text</b>
    let formattedText = text.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
  
    // Replace newlines with <br> tags
    formattedText = formattedText.replace(/\\n/g, "\n");

    formattedText = formattedText.replace(/\n/g, "<br>");
  
    return formattedText;
  };
  